// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB0-_kleaCJf5uzaDfdN3lNoZPPydaErHY",
  authDomain: "auradrobeco.firebaseapp.com",
  projectId: "auradrobeco",
  storageBucket: "auradrobeco.firebasestorage.app",
  messagingSenderId: "379174514966",
  appId: "1:379174514966:web:d47fbd59d01650a27f2037",
  measurementId: "G-QYTT5HHLCB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { app, analytics };

